import React, { FC } from "react";

import { CatchTitleBorder } from "~/components/atoms";
import { InfiniteScroll } from "~/components/molecules";

import { AiCompanyContextDetail } from "./AiCompanyContextDetail";

import { AiCompanyContextType } from "~/domains";

type PropsType = {
  aiCompanyContexts: AiCompanyContextType[];
  isLoading: boolean;
  hasNextPage?: boolean;
  fetchNextPage: () => void;
  refetch: () => void;
  className?: string;
};

export const AiCompanyContextDetails: FC<PropsType> = ({
  aiCompanyContexts,
  isLoading,
  hasNextPage,
  fetchNextPage,
  refetch,
  className = "",
}: PropsType) => {
  return (
    <div className={className}>
      <CatchTitleBorder text="更新履歴" />
      <InfiniteScroll
        itemsLength={aiCompanyContexts.length}
        nextFetchFunction={fetchNextPage}
        hasMore={hasNextPage}
        isLoading={isLoading}
        className={"mt-9"}
        scrollClassName={"space-y-6"}
        noContentMessage="AIカスタマイズがありません"
      >
        {aiCompanyContexts.map((aiCompanyContext) => (
          <AiCompanyContextDetail
            key={aiCompanyContext.id}
            aiCompanyContext={aiCompanyContext}
            refetch={refetch}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
};
